import React, { Component } from 'react';
import { getPathForApiCall } from '../Utility/ConditionValidator';

class LanguageComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false,
    };
    this.dropdownRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (this.dropdownRef && !this.dropdownRef.current.contains(event.target)) {
      this.setState({ dropdownOpen: false });
    }
  };

  toggleDropdown = () => {
    this.setState((prevState) => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  };

  render() {
    const {
      key,
      surveyID,
      surveyLanguages,
      isPublish,
      currentLanguageID,
      isHideLanguages,
    } = this.props.conduct;

    if (!surveyLanguages || surveyLanguages.length === 1) return '';
    const pathForApiCall = getPathForApiCall();
    const currentLanguage = surveyLanguages.find(
      (lang) => lang.languageID === currentLanguageID,
    );

    return (
      <div
        className={`survey_language_wrapper ${
          isHideLanguages ? 'this-hide' : ''
        }`}
        ref={this.dropdownRef}
      >
        <div className="dropdown">
          <button
            className="dropdown-btn"
            type="button"
            onClick={this.toggleDropdown}
          >
            <img
              src={`flag/${currentLanguage.languageName.toLowerCase()}.png`}
              alt={currentLanguage.languageName}
            />
          </button>
          {this.state.dropdownOpen && (
            <ul className="dropdown-menu">
              {surveyLanguages.map((v, i) => (
                <li
                  key={`lang${i}`}
                  style={{
                    display: `${v.languageName === 'TH' ? 'none' : 'block'}`,
                  }}
                >
                  <div
                    className={`dropdown-item ${
                      v.languageID === currentLanguageID ? 'active' : ''
                    }`}
                    onClick={() => {
                      if (v.languageID !== currentLanguageID) {
                        // clear answers if language changes (CB0168CF-166F-48B1-9D01-D2A2F4E55C9E)

                        this.props.setLanguages(
                          pathForApiCall,
                          key,
                          surveyID,
                          v.languageID,
                          isPublish,
                        );
                      }
                      this.toggleDropdown();
                    }}
                  >
                    <img
                      src={`flag/${v.languageName.toLowerCase()}.png`}
                      alt={v.languageName}
                    />
                    <span
                      style={{
                        fontWeight:
                          v.languageID === currentLanguageID
                            ? 'bold'
                            : 'normal',
                      }}
                    >
                      {v.languageName === 'CN'
                        ? '中文'
                        : v.languageName === 'EN'
                        ? 'English'
                        : v.languageName}
                    </span>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    );
  }
}

export default LanguageComponent;
